import { EventIcon } from "../icons";
import List from "./List";
import Edit from "./Edit";
import Create from "./Create";

export default {
  options: {
    group: "admin",
    roles: ["admin"],
  },
  icon: EventIcon,
  list: List,
  edit: Edit,
  create: Create,
};
